var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiwiBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3014",
    "data-name": "Group 3014",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.742,
    height: 52.327,
    viewBox: "0 0 58.742 52.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11225",
    "data-name": "Rectangle 11225",
    width: 58.742,
    height: 52.327,
    fill: "#22294b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3013",
    "data-name": "Group 3013",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    d: "M52.334,51.975a21.153,21.153,0,0,1-6.165-.949,24.5,24.5,0,0,1-6.122-2.857,22.478,22.478,0,0,1-9.062-10.895,15.313,15.313,0,0,1-.975-6.235,11.954,11.954,0,0,1,1.874-5.808c2.393-3.713,6.758-5.842,11.974-5.842a21.151,21.151,0,0,1,6.165.949,24.5,24.5,0,0,1,6.121,2.858,22.482,22.482,0,0,1,9.062,10.9,15.315,15.315,0,0,1,.975,6.235,11.955,11.955,0,0,1-1.873,5.808C61.916,49.846,57.551,51.975,52.334,51.975ZM43.858,21.691c-4.419,0-8.078,1.745-10.039,4.787-1.783,2.766-2.022,6.319-.672,10a20.169,20.169,0,0,0,8.148,9.752,20.76,20.76,0,0,0,11.04,3.439c4.419,0,8.078-1.745,10.039-4.787,1.783-2.766,2.021-6.319.672-10A20.173,20.173,0,0,0,54.9,25.13,20.758,20.758,0,0,0,43.858,21.691Z",
    transform: "translate(-6.969 -4.506)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3439",
    "data-name": "Path 3439",
    d: "M54.085,48.606a1.151,1.151,0,0,1,0-2.3c2.745,0,4.923-.937,5.977-2.572s1.035-3.859-.026-6.3a16.068,16.068,0,0,0-6.006-6.774,15.887,15.887,0,0,0-8.421-2.669c-2.745,0-4.923.937-5.977,2.572A1.151,1.151,0,1,1,37.7,29.312c1.486-2.305,4.37-3.627,7.912-3.627a18.209,18.209,0,0,1,9.669,3.036A19.668,19.668,0,0,1,59.44,32.3a16.319,16.319,0,0,1,2.707,4.209,11.087,11.087,0,0,1,.989,4.393A7.362,7.362,0,0,1,62,44.979C60.511,47.284,57.627,48.606,54.085,48.606Z",
    transform: "translate(-8.719 -5.969)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3440",
    "data-name": "Path 3440",
    d: "M43.826,58.446a18.037,18.037,0,0,1-3.475-.337,18.669,18.669,0,0,1-9.382-4.923,18.056,18.056,0,0,1-4.182-20.2,27.564,27.564,0,0,1,5.466-8.452,1.151,1.151,0,0,1,1.617,1.64h0a25.7,25.7,0,0,0-4.953,7.69,15.767,15.767,0,0,0,3.653,17.67,16.108,16.108,0,0,0,18.175,3.084,28.85,28.85,0,0,0,9.579-7.351,1.151,1.151,0,1,1,1.726,1.525A31.127,31.127,0,0,1,51.7,56.71,19.025,19.025,0,0,1,43.826,58.446Z",
    transform: "translate(-5.889 -5.624)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3441",
    "data-name": "Path 3441",
    d: "M20.447,52.674a17.3,17.3,0,0,1-8.311-2.143,21.554,21.554,0,0,1-6.7-5.77A27.864,27.864,0,0,1,.978,36.3a33.388,33.388,0,0,1,0-20.582,27.864,27.864,0,0,1,4.46-8.456,21.554,21.554,0,0,1,6.7-5.771A17.192,17.192,0,0,1,29,1.629a21.828,21.828,0,0,1,6.814,6.107,26.794,26.794,0,0,1,2.192,3.485c.027.05.053.1.079.151.09.173.181.353.27.533a1.151,1.151,0,1,1-2.065,1.019c-.081-.165-.165-.33-.249-.491-.022-.042-.042-.081-.063-.12l-.006-.011a24.488,24.488,0,0,0-2.005-3.19c-3.58-4.809-8.381-7.457-13.52-7.457-10.362,0-18.792,10.927-18.792,24.359s8.43,24.358,18.792,24.358a15.136,15.136,0,0,0,7.941-2.282,1.151,1.151,0,0,1,1.195,1.969A17.406,17.406,0,0,1,20.447,52.674Z",
    transform: "translate(0.151 0.151)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    d: "M18.543,16.348a3.1,3.1,0,0,1-3.1-3.1,1.151,1.151,0,1,1,2.3,0,.8.8,0,0,0,1.6,0,1.151,1.151,0,1,1,2.3,0A3.1,3.1,0,0,1,18.543,16.348Z",
    transform: "translate(-3.589 -2.811)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3443",
    "data-name": "Path 3443",
    d: "M25.892,9.7a3.1,3.1,0,0,1-3.1-3.1,1.151,1.151,0,1,1,2.3,0,.8.8,0,0,0,1.6,0,1.151,1.151,0,1,1,2.3,0A3.1,3.1,0,0,1,25.892,9.7Z",
    transform: "translate(-5.297 -1.265)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    d: "M33.241,16.348a3.1,3.1,0,0,1-3.1-3.1,1.151,1.151,0,1,1,2.3,0,.8.8,0,0,0,1.6,0,1.151,1.151,0,1,1,2.3,0A3.1,3.1,0,0,1,33.241,16.348Z",
    transform: "translate(-7.005 -2.811)",
    fill: "#22294b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwiBl);
export default __webpack_public_path__ + "static/media/Kiwi-bl.36ce6beb5d8fee27e16429da7ead3c55.svg";
export { ForwardRef as ReactComponent };